import React from 'react'

const Help = () => {
  return (
    <>
      <section className='w-100 px-3 pt-3 overflow-y-scroll scrollbar-hidden' style={{ backgroundColor: '#ecf6fa' }}>
        {/* Header */}
        <div className='bg-light px-3 py-2 rounded-3 d-flex flex-wrap align-items-center justify-content-between gap-3'>
          <h4 className='mb-0'>Help</h4>

          <select className="form-select w-auto">
            <option selected>Open this select menu</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>
      </section> 
    </>
  )
}

export default Help
